export var NIColours = {
  transparent: 'transparent',
  current: 'currentColor',
  black: '#000000',
  white: '#FFFFFF',
  blackAlpha: {
    700: 'rgba(0, 0, 0, 0.7)'
  },
  gray: {
    100: '#FCFCFC',
    200: '#F5F5F5',
    240: '#F8F8F8',
    250: '#F1F1F1',
    260: '#E9E9E9',
    270: '#E5E5E5',
    280: '#EEEEEE',
    300: '#EAEAEA',
    400: '#DDDDDD',
    450: '#CCCCCC',
    500: '#C1C1C1',
    600: '#A8A8A8',
    650: '#666666',
    700: '#838388',
    800: '#6D6D6D',
    850: '#666666',
    900: '#363636',
    950: '#323232',
    970: '#232323',
    980: '#1F1F1F'
  },
  blue: {
    50: '#F7FCFF',
    100: '#EBF2F9',
    150: '#EBF7FF',
    160: '#ECF9FF',
    200: '#D4EEFF',
    300: '#00CAFF',
    400: '#3B7DC5',
    500: '#2182EB',
    550: '#1B76D8',
    600: '#1076BC',
    650: '#0077C2',
    670: '#4CAAF0',
    700: '#05487A',
    800: '#32475E',
    900: '#0D1F63'
  },
  red: {
    50: '#FEFAFB',
    100: '#FFE4E5',
    200: '#FEA8A9',
    300: '#DB7777',
    400: '#D81F1F',
    500: '#AA1111',
    600: '#7E0A0E',
    700: '#D0011C',
    800: '#D40F0F'
  },
  green: {
    200: '#CDF7D4',
    300: '#7ED321',
    400: '#29A537',
    500: '#34AA40',
    600: '#019E1E'
  },
  neutral: {
    1: '#7FAED1',
    2: '#D4EEFF',
    3: '#EBF7FF',
    4: '#F7FCFF',
    5: '#CEDEF0',
    6: '#EBF2F9',
    7: '#ABD3FF',
    8: '#F9FCFF',
    9: '#FFF3F3',
    10: '#E6FFE6',
    11: '#F6FFF6',
    12: '#FFFDE3',
    13: '#FFFEF4',
    14: '#F6FBFF',
    15: '#EFF8FF',
    16: '#EFF9FF'
  },
  yellow: {
    100: '#FFF5CE',
    200: '#FFD530',
    500: '#F5A623',
    600: '#FF8000'
  }
};